export default "__VITE_PUBLIC_ASSET__2e0c3259__"